import { create, all } from 'mathjs';

const math = create(all, { number: 'BigNumber', precision: 20 });

export const CalculateTotal = (quantity: number, price: number, tax: number = 0, shipping: number = 0) => {
	const a = math.evaluate(`(${quantity}*${price})+${tax}+${shipping}`);
	return math.number(math.round(a, 2));
};

export const CalculateOrderTotalFromLineItems = (lineTtems: any[]) => {
	let grandTotal = 0;

	for (let i=0; i<lineTtems.length; i++) {
		const thisLi = lineTtems[i];
		grandTotal += (Number(thisLi.productTotal) || 0) + (Number(thisLi.tax) || 0) + (Number(thisLi.shippingCharge) || 0);
	}

	return math.number(math.round(grandTotal, 2));
	
};
